import axiosInstance from "@/api/axios-instance";

export interface PreviewBundleUser {
  id: string;
  full_name: string;
  phone_numbers: string[];
  preferred_phone_number: string | null;
}

export interface PreviewPhoneMatch {
  invitee_phone: string;
  matched_users: PreviewBundleUser[];
  is_already_mapped: boolean;
}

export interface PreviewProfessional {
  id: string;
  name: string;
}

export interface PreviewProfessionalMatch {
  session_professional: PreviewProfessional;
  bundle_professional: PreviewProfessional | null;
  will_change: boolean;
}

export interface PreviewBundle {
  id: string;
  name: string;
  status: string;
  end_date: string;
  total_session_quantity: number;
  utilized_session_quantity: number;
  projected_utilized: number;
  projected_status: string;
  will_complete: boolean;
}

export interface PreviewSession {
  source_id: string;
  name: string;
  current_usage_identifier: string | null;
  is_already_linked_to_same_bundle: boolean;
}

export interface UsageLinkPreview {
  bundle: PreviewBundle | null;
  mapped_users: PreviewBundleUser[];
  phone_match: PreviewPhoneMatch | null;
  professional_match: PreviewProfessionalMatch | null;
  session: PreviewSession;
  errors: string[];
  warnings: string[];
}

export async function previewUsageLink(
  source_id: string,
  usage_identifier: string
): Promise<UsageLinkPreview> {
  const response = await axiosInstance.post("/sessions/preview-usage-link", {
    source_id,
    usage_identifier,
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to fetch preview");
  }

  return response.data;
}
